import React from 'react';
import { string, bool, shape } from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { platformShape } from 'shapes';
import useSecondaryIcons from './hooks/useSecondaryIcons';
import { PrimaryCharacteristic, SecondaryCharacteristic } from './components';
import './CharacteristicBlock.scss';

export default function CharacteristicBlock({
    className,
    isB2B,
    isProProduct,
    hasBingo,
    isProSecondaryCharacteristic,
    isMFProduct,
    cdn,
    hasOneDayDelivery,
    hasFreeDelivery,
    lazyload,
    minFee,
    currency,
    platform,
}) {
    const rootClassnames = classnames('characteristic-block', className);

    const secondaryCharacteristics = useSecondaryIcons({
        isB2B,
        isProSecondaryCharacteristic,
        isMFProduct,
        hasOneDayDelivery,
        hasFreeDelivery,
        minFee,
        currency,
    });

    const shouldShowBingoLogo = !isB2B && hasBingo && isMFProduct;
    const shouldShowProLogo = isB2B && isProProduct;
    const shouldDisplayPrimaryCharacteristic =
        shouldShowBingoLogo || shouldShowProLogo || (isMFProduct && !isB2B);

    return (
        (shouldDisplayPrimaryCharacteristic ||
            secondaryCharacteristics.length > 0) && (
            <div className={rootClassnames}>
                {shouldDisplayPrimaryCharacteristic && (
                    <PrimaryCharacteristic
                        className="characteristic-block__primary"
                        isMFProduct={isMFProduct}
                        cdn={cdn}
                        lazyload={lazyload}
                        isB2B={isB2B}
                        isProProduct={isProProduct}
                        hasBingo={hasBingo}
                    />
                )}
                {secondaryCharacteristics.length > 0 && (
                    <SecondaryCharacteristic
                        className="characteristic-block__secondary"
                        characteristics={secondaryCharacteristics}
                    />
                )}

                {platform.IS_PLATFORM_DE && (
                    <div className="characteristic-block__legal">
                        <FormattedMessage
                            id="listing.productCard.legal"
                            defaultMessage="Incl. VAT, plus shipping"
                            description="Legal shipping label"
                        />
                    </div>
                )}
            </div>
        )
    );
}

CharacteristicBlock.propTypes = {
    className: string,
    isB2B: bool,
    isProProduct: bool,
    hasBingo: bool,
    isProSecondaryCharacteristic: bool,
    isMFProduct: bool,
    hasOneDayDelivery: bool,
    hasFreeDelivery: bool,
    cdn: shape({
        CDN_IMAGE: string,
    }).isRequired,
    lazyload: bool,
    minFee: string,
    currency: string.isRequired,
    platform: platformShape.isRequired,
};

CharacteristicBlock.defaultProps = {
    className: null,
    isB2B: false,
    isProProduct: false,
    hasBingo: false,
    isProSecondaryCharacteristic: false,
    isMFProduct: false,
    hasOneDayDelivery: false,
    hasFreeDelivery: false,
    lazyload: false,
    minFee: null,
};
